import pick from 'lodash/pick';

const multipleChoice1ToSingleChoice1 = (item, type) => {
    return Object.assign(
        {},
        pick(item, ['id', 'title', 'subtitle', 'required']),
        {
            type,
            choices: item.choices.map((choice) => Object.assign({}, choice)),
        });
};

export default multipleChoice1ToSingleChoice1;
